'use client';
import React from 'react';
import Product from '@models/product';
import { ProductVariation } from '@typings/product';
import ProductCard from '@repo/ui/src/components/ProductCard';
import GrillCardInterior from './GrillCardInterior';
import { logProduct } from '@utils/productWrapper';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

interface Props {
  variation: ProductVariation | Product;
  selected: boolean;
  dark?: boolean;
}

const GrillCard = ({ variation, selected, dark }: Props) => {
  const { locale } = useCurrentUrl();
  if (!variation) return null;

  return (
    <ProductCard
      selected={selected}
      productUrl={variation?.productUrl}
      dark={dark}
      onSelect={() => {
        logProduct('PRODUCT_CLICKED', {
          product: variation as any,
          list_name: 'Grill Feature Comparison',
          locale,
        });
      }}
    >
      <GrillCardInterior variation={variation} />
    </ProductCard>
  );
};

export default GrillCard;
